import { useEffect } from 'react';
import WellArcGISMapper from '@apps/components/mapViewers/WellArcGISMapper';



const PgPubMapViewer = () => {
  useEffect(() => {

  console.log("the code is running on Test server 2019 with React19 and Arcgis 5.1 with new compiler");

  }, []);

  return <WellArcGISMapper />;
};

export default PgPubMapViewer;
